import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import Home from "@/pages/Home";
import CardPage from "@/pages/CardPage";
import PreviewSimplified from "@/pages/PreviewSimplified";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/card" element={<CardPage />} />
          <Route path="/preview" element={<PreviewSimplified />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
